import { createFileRoute } from '@tanstack/react-router'
import { PartnerPortalPage } from '@/features/partner/pages/PartnerPortalPage'

export const Route = createFileRoute('/_app/partner/')({
  component: PartnerPortalPage,
})
